function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "idqqau6mma",
  d: "M21.63 4C22.937 4 24 5.032 24 6.3v13.4c0 1.268-1.063 2.3-2.37 2.3H4.37C3.063 22 2 20.968 2 19.7V6.3C2 5.032 3.063 4 4.37 4zm0 1.251H4.37c-.596 0-1.08.47-1.08 1.05V19.7c0 .578.484 1.049 1.08 1.049h17.26c.596 0 1.08-.47 1.08-1.05V6.3c0-.578-.484-1.049-1.08-1.049zM6.787 10.7c.356 0 .644.28.644.625v6.7c0 .345-.288.625-.644.625-.356 0-.645-.28-.645-.625v-6.7c0-.345.289-.625.645-.625zm6.213 0c.356 0 .645.28.645.625v6.7c0 .345-.289.625-.645.625-.356 0-.645-.28-.645-.625v-6.7c0-.345.289-.625.645-.625zm6.213 0c.356 0 .645.28.645.625v6.7c0 .345-.289.625-.645.625-.356 0-.644-.28-.644-.625v-6.7c0-.345.288-.625.644-.625zm-8.974 0c.356 0 .644.28.644.625v6.7c0 .345-.289.625-.644.625h-.69c-.357 0-.645-.28-.645-.625v-6.7c0-.345.288-.625.644-.625zm6.213 0c.356 0 .644.28.644.625v6.7c0 .345-.288.625-.644.625h-.69c-.356 0-.645-.28-.645-.625v-6.7c0-.345.289-.625.644-.625zm3.452-3.35c.356 0 .644.28.644.625 0 .346-.288.626-.644.626H6.096c-.356 0-.644-.28-.644-.626 0-.345.288-.625.644-.625z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1292 -1608) translate(1174 288) translate(0 64) translate(0 -156) translate(0 1380) translate(16 23) translate(90) translate(12 9)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "pg1zphwy9b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#idqqau6mma"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#FFF",
  fillRule: "nonzero",
  xlinkHref: "#idqqau6mma"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#FFF",
  mask: "url(#pg1zphwy9b)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0H26V26H0z"
})))))))))));

var SvgIcnCard = function SvgIcnCard(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnCard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn-card.63744e4d.svg";
export { ForwardRef as ReactComponent };